import PageLayout from './PageLayout';

export default PageLayout;



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/Brochure/Components/PageLayout/index.ts